import React from 'react';

export const FolderWrapperLazy = React.lazy(() =>
    import(
        /* webpackChunkName: "FolderWrapper" */
        'dibs-portfolio-folder'
    )
);
